import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

export type PositionCompetencyRequirement = {
  competencyId: string;
  competencyCode: string;
  requiredLevel: number;
  weight: number;
  isCritical: boolean;
};

export type PositionDto = {
  id: string;
  companyId: string;
  code: string;
  title: string;
  description?: string;
  divisionId?: string;
  orgLevelId?: string;
  competencyRequirements: PositionCompetencyRequirement[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export async function listPositions(companyId: string, includeInactive = false) {
  const res = await apiFetch(
    `${API_BASE_URL}/api/positions/company/${companyId}?includeInactive=${includeInactive}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { positions: PositionDto[] }; error?: string }>;
}

export async function createPosition(
  input: {
    companyId: string;
    code: string;
    title: string;
    description?: string;
    divisionId?: string;
    orgLevelId?: string;
    competencyRequirements?: PositionCompetencyRequirement[];
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/positions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { position: PositionDto }; error?: string }>;
}

export async function updatePosition(
  positionId: string,
  input: {
    companyId: string;
    title?: string;
    description?: string;
    divisionId?: string;
    orgLevelId?: string;
    competencyRequirements?: PositionCompetencyRequirement[];
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/positions/${positionId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { position: PositionDto }; error?: string }>;
}

export async function getPosition(positionId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/positions/${positionId}`, {
    headers: { 'Content-Type': 'application/json' },
  });
  return res.json() as Promise<{ success: boolean; data?: { position: PositionDto }; error?: string }>;
}

export async function deactivatePosition(positionId: string, companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/positions/${positionId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId }),
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}

export async function activatePosition(positionId: string, companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/positions/${positionId}/activate`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId }),
  });
  return res.json() as Promise<{ success: boolean; data?: { position: PositionDto }; error?: string }>;
}
